import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-customFile';
	$(base, context).each(function(){
		var component = $(this);
		var fileInput = component.find(base + '-input');
		var label = component.find(base +'-file');
		var defaultValue = label.html();
		var deleteFile = component.find(base + '-delete');

		fileInput.on('change', function(e) {
			var fileName = '';
			fileName = e.target.value.split('\\').pop();
			if (fileName) {
				label.html(fileName);
				component.addClass('m-active');
			} else {
				label.html(defaultValue);
				component.removeClass('m-active');
			}
		});

		deleteFile.on('click', function() {
			fileInput.get(0).value = '';
			label.html(defaultValue);
			component.removeClass('m-active');
		});
	});
});
